module.exports = __webpack_public_path__ + "img/04.d3109550.png";